export const OFFSHORE_REPORTS_STORE_ID = 'OffshoreReportsStore';
